import Request from "./constants/Request.api"
import Response from "./constants/Response.api"
import Api from "./Api"

const service_id = 1

class Service extends Api {
  constructor(user) {
    super()
    this.user = user
  }
  getServices = service => {
    const request = new Request({
      data: {
        url: "services" ,
        //token: "Bearer " + user.token,
      },
    })
    const response = this.getRequest(request)
    return response
  }

}

export default Service
